import Vue from 'vue'
import VueRouter from 'vue-router'
// 引入新的工具函数
//import { forceLoadLangCss } from '@/utils/loadCss'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/en/IndexView.vue')
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/en/NewsView.vue'),
    },
    {
        path: '/franchise',
        name: 'franchise',
        component: () => import('../views/en/FranchiseView.vue')
    },
    {
        path: '/contactus',
        name: 'contactus',
        component: () => import('../views/en/ContactusView.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/en/AboutView.vue')
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/en/RegisterView.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/en/LoginView.vue')
    },
    {
        path: '/password',
        name: 'password',
        component: () => import('../views/en/PasswordView.vue')
    },
    {
        path: '/newsdetail',
        name: 'newsdetail',
        component: () => import('../views/en/NewsDetailView.vue')
    },
    {
        path: '/merchatInReview',
        name: 'merchatInReview',
        component: () => import('../views/en/MerchantInReviewSucView.vue')
    },
    {
        path: '/chairmanSpeech',
        name: 'chairmanSpeech',
        component: () => import('../views/en/ChaiemanSpeechView.vue')
    },
    {
        path: '/companyIntroduction',
        name: 'companyIntroduction',
        component: () => import('../views/en/CompanyIntroductionView.vue')
    },
    {
        path: '/corporateCulture',
        name: 'corporateCulture',
        component: () => import('../views/en/CorporateCultureView.vue')
    },
    {
        path: '/merchantFranchise',
        name: 'merchantFranchise',
        component: () => import('../views/en/MerchantFranchiseView.vue')
    },
    {
        path: '/teamShow',
        name: 'teamShow',
        component: () => import('../views/en/TeamShowView.vue')
    },
    {
        path: '/personal',
        name: 'personal',
        component: () => import('../views/en/PersonalView.vue')
    },
    {
        path: '/merchant',
        name: 'merchant',
        component: () => import('../views/en/MerchantView.vue')
    },
    {
        path: '/useragreement',
        name: 'useragreement',
        component: () => import('../views/en/UserAgreementView.vue')
    },
    {
        path: '/privacypolicy',
        name: 'privacypolicy',
        component: () => import('../views/en/PrivacyPolicyView.vue')
    },

    {
        path: '/ar/index',
        name: 'index-ar',
        component: () => import('../views/ar/IndexView.vue')
    },
    {
        path: '/ar/news',
        name: 'news-ar',
        component: () => import('../views/ar/NewsView.vue'),
    },
    {
        path: '/ar/franchise',
        name: 'franchise-ar',
        component: () => import('../views/ar/FranchiseView.vue')
    },
    {
        path: '/ar/contactus',
        name: 'contactus-ar',
        component: () => import('../views/ar/ContactusView.vue')
    },
    {
        path: '/ar/about',
        name: 'about-ar',
        component: () => import('../views/ar/AboutView.vue')
    },
    {
        path: '/ar/register',
        name: 'register-ar',
        component: () => import('../views/ar/RegisterView.vue')
    },
    {
        path: '/ar/login',
        name: 'login-ar',
        component: () => import('../views/ar/LoginView.vue')
    },
    {
        path: '/ar/password',
        name: 'password-ar',
        component: () => import('../views/ar/PasswordView.vue')
    },
    {
        path: '/ar/newsdetail',
        name: 'newsdetail-ar',
        component: () => import('../views/ar/NewsDetailView.vue')
    },
    {
        path: '/ar/audit',
        name: 'audit-ar',
        component: () => import('../views/ar/AuditSucView.vue')
    },
    {
        path: '/ar/chairmanSpeech',
        name: 'chairmanSpeech-ar',
        component: () => import('../views/ar/ChaiemanSpeechView.vue')
    },
    {
        path: '/ar/companyIntroduction',
        name: 'companyIntroduction-ar',
        component: () => import('../views/ar/CompanyIntroductionView.vue')
    },
    {
        path: '/ar/corporateCulture',
        name: 'corporateCulture-ar',
        component: () => import('../views/ar/CorporateCultureView.vue')
    },
    {
        path: '/ar/merchantFranchise',
        name: 'merchantFranchise-ar',
        component: () => import('../views/ar/MerchantFranchiseView.vue')
    },
    {
        path: '/ar/teamShow',
        name: 'teamShow-ar',
        component: () => import('../views/ar/TeamShowView.vue')
    },
    {
        path: '/ar/personal',
        name: 'personal-ar',
        component: () => import('../views/ar/PersonalView.vue')
    },
    {
        path: '/ar/merchant',
        name: 'merchant-ar',
        component: () => import('../views/ar/MerchantView.vue')
    },
    {
        path: '/ar/merchatInReview',
        name: 'merchatInReview-ar',
        component: () => import('../views/ar/MerchantInReviewSucView.vue')
    },
    {
        path: '/useragreementar',
        name: 'useragreementar',
        component: () => import('../views/ar/UserAgreementView.vue')
    },
    {
        path: '/privacypolicyar',
        name: 'privacypolicyar',
        component: () => import('../views/ar/PrivacyPolicyView.vue')
    },

    {
        path: '/h5/content',
        component: () => import('@/views/h5/content'),
        hidden: true
      },
      {
        path: '/h5/message',
        component: () => import('@/views/h5/message'),
        hidden: true
      },
       {
        path: '/h5/register',
        component: null,
        component: () => import('@/views/h5/register'),
        hidden: true
      },
         {
        path: '/h5/registerar',
        component: null,
        component: () => import('@/views/h5/registerar'),
        hidden: true
      },
      {
        path: '/h5/product',
        component: () => import('@/views/h5/product'),
        hidden: true
      },

]

// const router = new VueRouter({
//     mode: 'history',
//     routes
// })

const router = new VueRouter({
    mode: 'history',
    base: '/', // 新增：强制所有路由的基准路径为根目录，解决 /ar/ 前缀导致的路径错误
    routes,
    // 新增：路由切换时滚动到顶部，避免样式渲染错位
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

// 整合后的路由前置钩子（base标签 + 暴力样式切换）
// router.beforeEach((to, from, next) => {
//     // 1. 保留你原来的 base 标签设置（解决资源路径解析问题）
//     const baseTag = document.querySelector('base') || document.createElement('base');
//     baseTag.href = '/';
//     if (!document.querySelector('base')) {
//         document.head.appendChild(baseTag);
//     }

//     // 2. 新增暴力样式切换逻辑（核心解决样式残留）
//     if (to.path.includes('/ar/')) {
//         forceLoadLangCss('ar'); // 阿拉伯语路由 → 加载阿拉伯语样式
//     } else {
//         forceLoadLangCss('en'); // 非阿拉伯语路由 → 加载英语样式
//     }

//     // 3. 放行路由
//     next();
// })
// 新增：路由切换后清理残留的多语言样式
// router.afterEach((to, from) => {
//     // 从阿拉伯语路由切换到英语路由
//     if (from.path.includes('/ar/') && !to.path.includes('/ar/')) {
//         unloadCss('style-ar'); // 卸载阿拉伯语样式
//         loadCss('style-en', require('@/assets/css/style.css')); // 确保英语样式加载
//     }
//     // 从英语路由切换到阿拉伯语路由
//     if (!from.path.includes('/ar/') && to.path.includes('/ar/')) {
//         unloadCss('style-en'); // 卸载英语样式
//         loadCss('style-ar', require('@/assets/css/style-ar.css')); // 确保阿拉伯语样式加载
//     }
// })


export default router
